import React, { Component } from 'react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import APIManager from './utils/APIManager';
import Header from './generic/header/header';
import Footer from './generic/footer/footer';
import Configuration from './utils/configuration';

import Pages from './pages/pages';
import NotFound from './pages/notFound/notFound';
import LoadingScreen from './generic/loadingScreen/loadingScreen';
import TopHome from './pages/elements/top/topHome';
import Functions from './utils/functions';
import HeaderImage from './pages/elements/headerImage';
import Scripts from './utils/scripts';
import Cookies from './pages/elements/cookies';

class Entry extends Component {
  constructor(props) {
    super(props);
    this.routerRef = React.createRef();  
  }
    state = {
      data: [],
      loading: true
    }
    getData = () => {
      APIManager.getAll().then((value) => {
        this.setState({
          data: value,
          loading: false
        })
        document.documentElement.style.overflowY = "auto";
        document.querySelector(".body").style.display = "block";

        let loadScript = document.createElement("script");
        loadScript.className = "loadScripts";
        loadScript.setAttribute("src", `${Configuration.WEB_PATH}js/loadFunctions.js`);
        document.body.appendChild(loadScript);

      }).catch(reason => console.error(`Error en la obtención de datos: ${reason}`))
    }
    componentDidMount() {
      this.getData();
      this.path = Functions.getActualPath(this.routerRef.current.history.location.pathname);
      this.element = this.path ? this.state.data[this.path] : false;

      document.documentElement.style.overflowY = "hidden";
      document.querySelector(".body").style.display = "none";

    }
    
    render() {
      
      return (
        <BrowserRouter ref={this.routerRef} basename={`/${Configuration.WEB_ROOT_FRONT}`}>
          {
            <LoadingScreen className={!this.state.loading && `loadingScreen--hidden`}/>
          }
          <div className="body">
            <Cookies />
            <Header data={this.state.data} />
            <TopHome element={this.element}/>
            <HeaderImage />
            <Switch>
              <Route exact path={["/", ...Configuration.urlPages]} component={() => <Pages data={this.state.data} />} />
              <Route component={NotFound} />
            </Switch>
            <Footer data={this.state.data} />
          </div>
          <Scripts />
          
        </BrowserRouter>
      )
    }
}

export default Entry;